/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * roko_safety_bot
 * Roko Safety Bot - Simplified Backend API
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ConversationPromptRequest,
  ConversationResponse,
  CreateConversationBody,
  DeleteConversation200,
  HTTPValidationError,
  ListConversationsParams
} from '.././models';

import { customInstance } from '../../mutator';
import type { ErrorType } from '../../mutator';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * List conversations for the authenticated user.
 * @summary List conversations
 */
export const listConversations = (
    params?: ListConversationsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ConversationResponse[]>(
      {url: `/conversations`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getListConversationsQueryKey = (params?: ListConversationsParams,) => {
    return [
    `/conversations`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getListConversationsQueryOptions = <TData = Awaited<ReturnType<typeof listConversations>>, TError = ErrorType<HTTPValidationError>>(params?: ListConversationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listConversations>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListConversationsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listConversations>>> = ({ signal }) => listConversations(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listConversations>>, TError, TData> & { queryKey: QueryKey }
}

export type ListConversationsQueryResult = NonNullable<Awaited<ReturnType<typeof listConversations>>>
export type ListConversationsQueryError = ErrorType<HTTPValidationError>


/**
 * @summary List conversations
 */

export function useListConversations<TData = Awaited<ReturnType<typeof listConversations>>, TError = ErrorType<HTTPValidationError>>(
 params?: ListConversationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listConversations>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListConversationsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Create a new conversation owned by the authenticated user.
 * @summary Create a conversation
 */
export const createConversation = (
    createConversationBody: CreateConversationBody,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ConversationResponse>(
      {url: `/conversations`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createConversationBody, signal
    },
      options);
    }
  


export const getCreateConversationMutationOptions = <TError = ErrorType<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createConversation>>, TError,{data: CreateConversationBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createConversation>>, TError,{data: CreateConversationBody}, TContext> => {

const mutationKey = ['createConversation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createConversation>>, {data: CreateConversationBody}> = (props) => {
          const {data} = props ?? {};

          return  createConversation(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateConversationMutationResult = NonNullable<Awaited<ReturnType<typeof createConversation>>>
    export type CreateConversationMutationBody = CreateConversationBody
    export type CreateConversationMutationError = ErrorType<HTTPValidationError>

    /**
 * @summary Create a conversation
 */
export const useCreateConversation = <TError = ErrorType<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createConversation>>, TError,{data: CreateConversationBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createConversation>>,
        TError,
        {data: CreateConversationBody},
        TContext
      > => {

      const mutationOptions = getCreateConversationMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Retrieve a conversation owned by the authenticated user.
 * @summary Get conversation details
 */
export const getConversation = (
    conversationId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ConversationResponse>(
      {url: `/conversations/${conversationId}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetConversationQueryKey = (conversationId?: string,) => {
    return [
    `/conversations/${conversationId}`
    ] as const;
    }

    
export const getGetConversationQueryOptions = <TData = Awaited<ReturnType<typeof getConversation>>, TError = ErrorType<HTTPValidationError>>(conversationId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getConversation>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetConversationQueryKey(conversationId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getConversation>>> = ({ signal }) => getConversation(conversationId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(conversationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getConversation>>, TError, TData> & { queryKey: QueryKey }
}

export type GetConversationQueryResult = NonNullable<Awaited<ReturnType<typeof getConversation>>>
export type GetConversationQueryError = ErrorType<HTTPValidationError>


/**
 * @summary Get conversation details
 */

export function useGetConversation<TData = Awaited<ReturnType<typeof getConversation>>, TError = ErrorType<HTTPValidationError>>(
 conversationId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getConversation>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetConversationQueryOptions(conversationId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Soft-delete a conversation owned by the authenticated user.
 * @summary Delete a conversation
 */
export const deleteConversation = (
    conversationId: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<DeleteConversation200>(
      {url: `/conversations/${conversationId}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteConversationMutationOptions = <TError = ErrorType<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteConversation>>, TError,{conversationId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteConversation>>, TError,{conversationId: string}, TContext> => {

const mutationKey = ['deleteConversation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteConversation>>, {conversationId: string}> = (props) => {
          const {conversationId} = props ?? {};

          return  deleteConversation(conversationId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteConversationMutationResult = NonNullable<Awaited<ReturnType<typeof deleteConversation>>>
    
    export type DeleteConversationMutationError = ErrorType<HTTPValidationError>

    /**
 * @summary Delete a conversation
 */
export const useDeleteConversation = <TError = ErrorType<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteConversation>>, TError,{conversationId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteConversation>>,
        TError,
        {conversationId: string},
        TContext
      > => {

      const mutationOptions = getDeleteConversationMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Send a message and receive an AI-generated response.
 * @summary Send a conversation prompt
 */
export const sendPrompt = (
    conversationId: string,
    conversationPromptRequest: ConversationPromptRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ConversationResponse>(
      {url: `/conversations/${conversationId}/prompt`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: conversationPromptRequest, signal
    },
      options);
    }
  


export const getSendPromptMutationOptions = <TError = ErrorType<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendPrompt>>, TError,{conversationId: string;data: ConversationPromptRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof sendPrompt>>, TError,{conversationId: string;data: ConversationPromptRequest}, TContext> => {

const mutationKey = ['sendPrompt'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendPrompt>>, {conversationId: string;data: ConversationPromptRequest}> = (props) => {
          const {conversationId,data} = props ?? {};

          return  sendPrompt(conversationId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SendPromptMutationResult = NonNullable<Awaited<ReturnType<typeof sendPrompt>>>
    export type SendPromptMutationBody = ConversationPromptRequest
    export type SendPromptMutationError = ErrorType<HTTPValidationError>

    /**
 * @summary Send a conversation prompt
 */
export const useSendPrompt = <TError = ErrorType<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendPrompt>>, TError,{conversationId: string;data: ConversationPromptRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof sendPrompt>>,
        TError,
        {conversationId: string;data: ConversationPromptRequest},
        TContext
      > => {

      const mutationOptions = getSendPromptMutationOptions(options);

      return useMutation(mutationOptions);
    }
    